import { Box, Button, Group, rem, Text } from '@mantine/core';
import { Dropzone, MS_WORD_MIME_TYPE } from '@mantine/dropzone';
import { IconCloudUpload, IconDownload, IconX } from '@tabler/icons-react';
import mammoth from 'mammoth';
import { useRef, useState } from 'react';

export function DocxUpload({ updateEditorStateFromHtml }) {
  const openRef = useRef<() => void>(null);
  const [error, setError] = useState('');

  const handleDrop = async (files) => {
    const file = files[0];
    if (file) {
      if (file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
        setError('Please upload a valid .docx file.');
        return;
      }

      try {
        const arrayBuffer = await file.arrayBuffer();
        const { value: html } = await mammoth.convertToHtml({ arrayBuffer });
        updateEditorStateFromHtml(html);
        setError('');
      } catch (err) {
        setError('An error occurred while converting the file.');
        console.error(err);
      }
    }
  };

  return (
    <Box ta="center" pos="relative" mb="md">
      <Dropzone
        w="100%"
        openRef={openRef}
        onDrop={handleDrop}
        radius="md"
        accept={MS_WORD_MIME_TYPE}
        maxSize={30 * 1024 ** 2}
        pb={rem(50)}
        style={{ borderWidth: rem(1) }}
      >
        <div style={{ pointerEvents: 'none' }}>
          <Group justify="center">
            <Dropzone.Accept>
              <IconDownload style={{ width: rem(50), height: rem(50) }} color="blue" stroke={1.5} />
            </Dropzone.Accept>
            <Dropzone.Reject>
              <IconX style={{ width: rem(50), height: rem(50) }} color="red" stroke={1.5} />
            </Dropzone.Reject>
            <Dropzone.Idle>
              <IconCloudUpload style={{ width: rem(50), height: rem(50) }} stroke={1.5} />
            </Dropzone.Idle>
          </Group>

          <Text ta="center" fw={700} fz="lg" mt="xl">
            <Dropzone.Accept>Drop files here</Dropzone.Accept>
            <Dropzone.Reject>File less than 10mb</Dropzone.Reject>
            <Dropzone.Idle>Upload .DOCX file</Dropzone.Idle>
          </Text>
          <Text ta="center" fz="sm" mt="xs" c="dimmed">
            Drag&apos;n&apos;drop files here to upload.
          </Text>
        </div>
      </Dropzone>

      <Button
        size="md"
        mb="md"
        radius="xl"
        ta="center"
        w={rem(250)}
        onClick={() => openRef.current?.()}
      >
        Select files
      </Button>
    </Box>
  );
}
